import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    template: `
    <h1 mat-dialog-title>{{ data.confirmationText }}</h1>
    <div mat-dialog-actions>
      <button mat-button (click)="close(false)">No</button>
      <button mat-button (click)="close(true)">Yes</button>
    </div>
  `,
    standalone: false
})
export class ConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { confirmationText: string;}
    ) {}

  close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
